// CustomHeader.js
import React, { Children, ReactNode, useEffect, useState } from "react";
import { Layout, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import styles from "./LayoutHeader.module.scss";
import { T_PageTitle } from "store/pageTitleSlice";

const CustomHeader = ({
  headerLeft,
  pageTitle,
  headerWidth,
  children,
  humburger,
}: {
  headerLeft?: ReactNode;
  pageTitle: T_PageTitle;
  headerWidth: string;
  children?: React.ReactNode;
  humburger?: React.ReactNode;
}) => {
  const [isSmallScreen, setISSmallScreen] = useState(false);
  useEffect(() => {
    const updateMarginLeft = () => {
      if (window.innerWidth >= 1024) {
        setISSmallScreen(false);
      } else {
        setISSmallScreen(true);
      }
    };

    window.addEventListener("resize", updateMarginLeft);
    updateMarginLeft();

    return () => window.removeEventListener("resize", updateMarginLeft); //
  }, []);
  return (
    <Layout.Header
      className={styles.header}
      style={{ width: headerWidth, marginRight: headerWidth === "100%" ? "24px" : "" }}
    >
      {headerLeft ?? (
        <Breadcrumb
          items={pageTitle.map((el, i) => ({
            key: i,
            title: el?.link ? <Link to={el?.link}>{el.title}</Link> : el.title,
          }))}
        />
      )}
      {isSmallScreen ? (
        children
      ) : (
        <div style={{ marginRight: headerWidth === "100%" ? 56 : undefined, height: "fit-content" }}>{children}</div>
      )}
      {humburger}
    </Layout.Header>
  );
};

export default CustomHeader;
